import { getMonthOptions, getYearOptions } from '@/_schemas/generic';
import { defaultStatus } from '@/_schemas/status-input';

import type { CompanyFormSchema } from '../schemas';

const monthsOptions = getMonthOptions();
const estYearOptions = getYearOptions();

export const defaultValues: Readonly<CompanyFormSchema> = {
  id: -1,
  name: '',
  short_name: '',
  status: defaultStatus,
  year_established: estYearOptions[0],
  account_number: -1,
  consumers: null,
  annual_meeting_month: monthsOptions[0],
  zoom_meeting_code: '',
  logo: null,
  brand: null,
  partner: null,
  phone_numbers: null,
  account_manager: null,
  audience: null,
  billing_system: null,
  industries: null,
  magazine: null,
  organization_type: null,
  relationship_score: null,
  contacts: null,
  domains: null,
  addresses: null,
  gnt_affiliations: [],
  non_gnt_affiliations: [],
  all_gnt_affiliations: [],
  all_non_gnt_affiliations: [],
  subsidiaries: [],
  primary_subsidiaries: null,
  primary_contact: null,
  current_web_provider_type: null,
  current_web_provider_id: -1,
  tax_id: '',
  exempt: '',
  billing_term: null,
  harvest: '',
  freshdesk: '',
  box: '',
  client_assigned_vendor_id: '',
  override_payable_name: '',
  agreements: [],
  marketing_campaigns: [],
} as const;
